import { Stack } from "@mui/material";
import React, { useContext } from "react";
import { PageContext } from "../../context/PageContext";
import { CompanySelector } from "./CompanySelector";

const Settings = () => {
  const { setNewTitle } = useContext(PageContext);

  React.useEffect(() => {
    setNewTitle("Settings");
  }, [setNewTitle]);

  return (
    <Stack spacing={2} pb={4} minHeight="100%">
      <CompanySelector />
    </Stack>
  );
};

export default Settings;
